module.exports = __webpack_public_path__ + "static/img/search_subcat_item_08_show.46c3ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/search_subcat_item_08_show.jpg
// module id = WIau
// module chunks = 0